import { pick } from 'underscore';
import { readConversionGoalDetails } from '@bingads-webui-campaign-react/perf-max-data';

const whitelistedSchemaPropertyKeys = [
  'IsActiveConversionGoalPresent', 'IsActiveConversionGoalPresentWithValidRevenueValue',
];

export const modelToViewModelForConversionGoalDetails = (model) => {
  const data = pick(model, whitelistedSchemaPropertyKeys);

  return data;
};

export const loadConversionGoalDetails = ({ cid, aid }) => readConversionGoalDetails(cid, aid)
  .then(modelToViewModelForConversionGoalDetails);
